import { Theme } from "../constants";

export default {
    tabsContainer:{  
      display:"flex",
      justifyContent:"center"
    },
    tabsGroup:{
        display:"flex",
        justifyContent:"center",
        borderRadius: "24px",
        border: "1px solid #D4D4D4",
    },
    tabContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
    },
    tab:{  
        color: Theme.TEXT_PRIMARY_BLACK,
        padding: "5px 20px",
        outline: 0,
        border: "none",
        background: "none",
        height: "100%",
    },
    tabActive:{
        fontWeight: "bold",
    },
    activeTabBorder: {
        border: `2px solid ${Theme.PRIMARY}`,
        zIndex: 2,
        borderRadius: "8px",
    },
    nonActiveTabBorder: {
        border: `2px solid rgb(255 255 255 / 0%)`,
    },
    floatingBottomBorder: {
        position: "absolute",
        bottom: 1,
        width: "100%",
        border: "0.5px solid #E7E5E5",
    },
    titleContainer: {
        display: "flex", 
        alignItems: "center"
    },
    titleIcon: {
        marginRight: "6px",
    },
    titleInBold: {
        fontWeight: "700", 
        fontSize: "24px", 
        marginRight: "6px"
    },
    panels: {
        display: "block",
        width: "100%",
    },
    panel:{
        display: "none",
        padding: "10px",
    },
    panelActive:{
        display: "block",
    }
}